import React from 'react';
import { useRouter } from 'expo-router';
import DropdownMenuItem from '@/components/DropdownMenu/DropdownMenuItem';
import DropdownMenuItemDivider from '@/components/DropdownMenu/DropdownMenuItemDivider';
import DropdownMenuLabel from '@/components/DropdownMenu/DropdownMenuLabel';
import { useBusinessWorkspace } from './BusinessWorkspaceContext';

export default function BusinessWorkspaceMenu() {
  const context = useBusinessWorkspace(), router = useRouter();
  if (!context?.workspaces.length) return null;
  return <><DropdownMenuLabel text="Gab AI Business" />
    {context.workspaces.map(workspace => <DropdownMenuItem key={workspace.id} title={workspace.name}
      icon="building" onSelect={() => router.push(`/settings?tab=business&workspace=${encodeURIComponent(workspace.id)}`)} />)}
    <DropdownMenuItemDivider />
  </>;
}
